<div class="overlay-inner-wrapper">
  @if (!isInspektion()) {
    <header class="header-2">
      <div class="branding">
        <span class="title">{{ titel() | mrTranslate }}</span>
      </div>
      <div class="header-actions">
        <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
          <cds-icon shape="times" />
        </a>
      </div>
    </header>
  }
  @if (stammdaten()?.length) {
    <div
      id="stammdatenWrapper"
      class="w-100-p padding-10-lr padding-12-b scroll-y"
      [ngClass]="isInspektion() ? 'h-100' : 'h-60'">
      <div class="clr-row nxm" [class]="isInspektion() ? 'auto-height-lg-100' : 'auto-height-lg-60'">
        <form
          id="stammdaten-form"
          #stammDatenForm
          clrForm
          (ngSubmit)="saveIfValid()"
          clrLabelSize="12"
          class="width100 clr-col-12 clr-col-lg-6 auto-height-lg scroll-y">
          <table class="table margin-0-t table-compact nowrap">
            <thead style="position: sticky; top: -7px; z-index: 3">
              <tr>
                <th class="left">{{ 'Objekt' | mrTranslate }}</th>
                <th class="left">{{ 'Bezeichnung' | mrTranslate }}</th>
                <th>{{ 'Pflicht' | mrTranslate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (stamm of stammdaten(); track stamm.DBField) {
                <tr>
                  @if (stamm.isHeader) {
                    <th class="headerRow left">
                      {{ stamm['Translate'] ? (stamm.Objekt | mrTranslate) : stamm.Objekt }}
                    </th>
                    <th class="headerRow"></th>
                    <th class="headerRow"></th>
                  } @else {
                    <td class="left">
                      @if (drehung.isOn) {
                        @switch (stamm.DBField) {
                          @case ('Startpunkt') {
                            {{ 'Endpunkt Bezeichnung' | mrTranslate }}
                          }
                          @case ('Endpunkt') {
                            {{ 'Startpunkt Bezeichnung' | mrTranslate }}
                          }
                          @case ('StartMeter') {
                            {{ 'Endmeter' | mrTranslate }}
                          }
                          @case ('EndMeter') {
                            {{ 'Startmeter' | mrTranslate }}
                          }
                          @default {
                            {{ stamm['Translate'] ? (stamm.Objekt | mrTranslate) : stamm.Objekt }}
                          }
                        }
                      } @else {
                        {{ stamm['Translate'] ? (stamm.Objekt | mrTranslate) : stamm.Objekt }}
                      }
                    </td>
                    <td class="left">
                      @if ((stamm.DBField.startsWith('Start') || stamm.DBField.startsWith('End')) && drehung.isOn) {
                        <clr-input-container>
                          <input
                            clrInput
                            type="text"
                            name="{{ stamm.Objekt }}"
                            [ngModel]="stamm.Bezeichnung"
                            disabled />
                        </clr-input-container>
                      } @else {
                        @switch (+stamm.Fieldtyp) {
                          <!-- Texteingabefeld ohne Auswahl -->
                          @case (0) {
                            <clr-input-container>
                              <input
                                clrInput
                                type="text"
                                name="{{ stamm.Objekt }}"
                                [(ngModel)]="stamm.Bezeichnung"
                                [required]="stamm.Pflicht" />
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                            </clr-input-container>
                          }
                          <!-- Texteingabefeld mit Auswahl -->
                          @case (1) {
                            <clr-control-container>
                              <app-datalist-input
                                [datalist]="stamm.Selection"
                                placeholder=""
                                [name]="stamm.Objekt"
                                [(ngModel)]="stamm.Bezeichnung"
                                [required]="!!stamm.Pflicht" />
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                            </clr-control-container>
                          }
                          <!-- STRIKT Texteingabefeld nur vom Auswahl -->
                          @case (6) {
                            @let selection = stamm.Selection | keyvalue;
                            @let wListe = selection | array: 'map' : mapKeysToNumber;

                            <clr-select-container>
                              <select
                                clrSelect
                                [name]="stamm.Objekt"
                                [ngModel]="stamm.Bezeichnung"
                                (ngModelChange)="stamm.Bezeichnung = +$event"
                                [required]="!!stamm.Pflicht"
                                [inTableValidator]="wListe">
                                <option [disabled]="stamm.Pflicht" [ngValue]="null"></option>
                                @if (stamm.Bezeichnung && !wListe.includes(stamm.Bezeichnung)) {
                                  <option [value]="stamm.Bezeichnung" class="invalid-red">
                                    {{ stamm.Bezeichnung }}
                                  </option>
                                }
                                @for (wert of selection; track +wert.key) {
                                  <option [ngValue]="+wert.key">{{ wert.value }}</option>
                                }
                              </select>
                              <clr-control-error *clrIfError="'not-in-Table'">
                                {{ 'Wählen Sie einen Wert aus der Liste aus.' | mrTranslate }}
                              </clr-control-error>
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                              @if (stamm.Objekt == 'Zählertyp' || stamm.Objekt == 'Stellkraftzählertyp') {
                                <clr-control-helper style="max-width: 30vw; text-wrap: wrap">
                                  {{
                                    'Das neue Zählerprogramm wird erst nach Speichern und Öffnen der Inspektion geladen.'
                                      | mrTranslate
                                  }}
                                </clr-control-helper>
                              }
                            </clr-select-container>
                          }
                          <!-- Zahleneingabefeld float -->
                          @case (2) {
                            <clr-number-input-container>
                              <input
                                clrNumberInput
                                name="{{ stamm.Objekt }}"
                                [(ngModel)]="stamm.Bezeichnung"
                                type="number"
                                step="0.1"
                                min="0"
                                [required]="stamm.Pflicht"
                                (change)="
                                  (stamm.DBField == 'StartMeter' || stamm.DBField == 'EndMeter') && calcLaenge()
                                "
                                [disabled]="stamm.DBField == 'Laenge' && (typ_Line_Point() | objtype) == 'line'" />
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                            </clr-number-input-container>
                          }
                          <!-- Zahleneingabefeld int -->
                          @case (3) {
                            <clr-number-input-container>
                              <input
                                clrNumberInput
                                name="{{ stamm.Objekt }}"
                                [(ngModel)]="stamm.Bezeichnung"
                                type="number"
                                step="1"
                                min="0"
                                [required]="stamm.Pflicht" />
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                            </clr-number-input-container>
                          }
                          <!-- Ja/Nein Einegabe -->
                          @case (4) {
                            <clr-toggle-container>
                              <clr-toggle-wrapper>
                                <input
                                  clrToggle
                                  name="{{ stamm.Objekt }}"
                                  [(ngModel)]="stamm.Bezeichnung"
                                  type="checkbox"
                                  [required]="stamm.Pflicht" />
                              </clr-toggle-wrapper>
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                            </clr-toggle-container>
                          }
                          <!-- Datum -->
                          @case (5) {
                            <clr-date-container>
                              <input
                                clrDate
                                name="{{ stamm.Objekt }}"
                                autocomplete="off"
                                type="date"
                                [required]="stamm.Pflicht"
                                [ngModel]="stamm.Bezeichnung | localeDate"
                                (ngModelChange)="stamm.Bezeichnung = localeDate.tosql($event)"
                                [ngModelOptions]="{ updateOn: 'blur' }" />
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                            </clr-date-container>
                          }
                        }
                      }
                    </td>
                    <td>
                      @if (stamm.Pflicht) {
                        <cds-icon shape="success-standard" solid="true" style="fill: #2ec0ff" />
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </form>
        <div class="clr-col-12 clr-col-lg-6 auto-height-lg">
          <app-preview-thumbnails
            style="margin-top: 0px"
            [readonly]="!opruefid()"
            [maxAmount]="6"
            [acceptTypes]="'image/*'"
            (deleteFile)="deleteFile($event)"
            [allowCameraVideo]="false" />
          <form clrForm class="width100" clrLabelSize="12">
            @if ((typ_Line_Point() | objtype) == 'point') {
              <div class="clr-row margin-0-r" style="align-items: baseline">
                <div class="clr-col-10">
                  <clr-select-container>
                    <label class="clr-col-4">{{ 'Messpunktskizze' | mrTranslate }}</label>
                    <select clrSelect name="skizzenname" [(ngModel)]="selectedSkizzeName" class="clr-col-8">
                      <option value="">
                        {{ 'Keine' | mrTranslate }}
                      </option>
                      @for (item of skizzenListe(); track $index) {
                        <option [value]="item">{{ item }}</option>
                      }
                    </select>
                  </clr-select-container>
                </div>
                <div class="clr-col-2">
                  <button class="btn" (click)="fInput.click()">
                    <cds-icon shape="image" />
                  </button>
                  <input
                    #fInput
                    accept=".png"
                    (change)="onBildChanged($event.target.files[0])"
                    type="file"
                    id="fileUpload"
                    name="fileUpload"
                    style="display: none"
                    (click)="$event.target.value = null" />
                </div>
              </div>
              <br />
              @if (skizzeSanitized()) {
                <div class="preview mw-100-p w-100-p">
                  <img [src]="skizzeSanitized()" class="invertWhenDark" (click)="openSkizze()" />
                </div>
              }
            }

            @if (isInspektion()) {
              <clr-textarea-container>
                <label>{{ 'Bemerkung zur Prüfung' | mrTranslate }}</label>
                <textarea name="bemerkung_pruefung" clrTextarea [(ngModel)]="bemerkung_pruefung"></textarea>
              </clr-textarea-container>
            }

            <clr-textarea-container>
              <label>{{ 'Bemerkung' | mrTranslate }}</label>
              <textarea name="bemerkung" clrTextarea [(ngModel)]="bemerkung"></textarea>
            </clr-textarea-container>
          </form>
        </div>
      </div>
      @if (!isInspektion()) {
        <div class="margin-12-t padding-10-l">
          <button type="submit" form="stammdaten-form" class="btn btn-primary">
            {{ 'Speichern' | mrTranslate }}
          </button>
        </div>
      }
    </div>
  }
</div>

@if (imageMedia()) {
  <app-mediaviewmodal (onClose)="imageMedia.set(undefined)" [media]="imageMedia()" />
}
